'use client';

// Lazy wrapper around fireButtonClick so onClick handlers can import this small
// client module without pulling the analytics module (gtm + isbot + journey)
// into the critical bundle. After hydration the AnalyticsProvider page-view
// effect has already resolved the import, so subsequent calls hit the cache.
export function trackButtonClick(targetName: string): void {
  void import('@/lib/analytics').then((analytics) => {
    analytics.fireButtonClick(targetName);
  });
}
